import { LoadingButton } from '@mui/lab';
import {
  Box,
  Card,
  CardContent,
  Container,
  Divider,
  FormControlLabel,
  FormGroup,
  Grid,
  Typography
} from '@mui/material';
import { useState } from 'react';
import SidebarMesages from '~/components/PersonalCoverage/SidebarMesages';
import * as styles from './styles';
// import IOSSwitch from '~/components/IOSSwitch'
import { yupResolver } from '@hookform/resolvers/yup';
import { Controller, SubmitHandler, useForm } from 'react-hook-form';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Input from '~/components/Input';
import InputSelect from '~/components/InputSelect';
import IOSSwitch from '~/components/IOSSwitch';
import { useContractLoader } from '~/hooks/useContractLoader';
import { ContractPostEmergency } from '~/services/modules/contract/types';
import useStore from '~/store';
import schema from './validation';

const itemsQuerstionSecurity = [
  {
    value: 1,
    label: 'Nome do primeiro cachorro'
  },
  {
    value: 2,
    label: 'time que torce'
  },
  {
    value: 3,
    label: 'Nome da primeira professora'
  }
];

export default function HelpZipcodePage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);
  const [callThePolice, setcallThePolice] = useState(false);

  // Hook para carregar dados do contrato
  const { contract_id } = useContractLoader({ stepName: 'step5' });

  const {
    handleSubmit,
    control,
    setValue,
    formState: { errors, dirtyFields }
  } = useForm<ContractPostEmergency>({
    resolver: yupResolver(schema)
  });

  const { contractAsyncPostEmergency } = useStore((store) => ({
    contractAsyncPostEmergency: store.contractAsyncPostEmergency
  }));

  const onSubmit: SubmitHandler<ContractPostEmergency> = (data) => {
    setLoading(true);
    if (contract_id) {
      const orgParam = searchParams.get('org');
      contractAsyncPostEmergency(
        contract_id,
        {
          name: typeof data.name === 'string' ? data.name.trim() : data.name,
          security_question: +data.security_question,
          security_answer:
            typeof data.security_answer === 'string' ? data.security_answer.trim() : data.security_answer,
          mobile_phone: data.mobile_phone,
          call_the_police: callThePolice
        },
        orgParam ?? undefined
      )
        .then(() => {
          setLoading(false);

          const contract_hash_id = searchParams.get('cid');
          const source = searchParams.get('source');
          const params = new URLSearchParams();
          if (contract_hash_id) params.set('cid', contract_hash_id);
          if (source) params.set('source', source);
          if (orgParam) params.set('org', orgParam);

          navigate(`/contract/download?${params.toString()}`);
        })
        .catch(() => {
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="lg" sx={styles.container}>
      <Grid container spacing={2}>
        <Grid item md={8} xs={12}>
          <Card>
            <CardContent>
              <Box sx={styles.headerContainer}>
                <Typography variant="h6" align="center">
                  Dados para emergência
                </Typography>
              </Box>
              <Divider variant="middle" />
              <form onSubmit={handleSubmit(onSubmit)}>
                <Box sx={styles.containerForm}>
                  <Typography variant="h6" fontWeight="bold">
                    5 - Dados para emergência
                  </Typography>
                  <Controller
                    name="name"
                    control={control}
                    render={({ field }) => (
                      <>
                        <Input
                          label="Contato (em caso de emergência)"
                          placeholder="Nome Completo"
                          error={errors?.name ? true : false}
                          isDirty={dirtyFields.name}
                          helperText={errors?.name?.message}
                          {...field}
                        />
                      </>
                    )}
                  />
                  <Controller
                    name="mobile_phone"
                    control={control}
                    render={({ field }) => (
                      <>
                        <Input
                          label="Celular"
                          placeholder="(XX) X XXXX-XXXX"
                          mask="phone"
                          error={errors?.mobile_phone ? true : false}
                          isDirty={dirtyFields.mobile_phone}
                          helperText={errors?.mobile_phone?.message}
                          {...field}
                        />
                      </>
                    )}
                  />
                  <FormGroup sx={styles.switchStyle}>
                    <FormControlLabel
                      control={
                        <IOSSwitch
                          sx={{ m: 1 }}
                          onChange={() => {
                            setcallThePolice(!callThePolice);
                            setValue('call_the_police', !callThePolice);
                          }}
                        />
                      }
                      label="Dependendo da localização da ocorrência, podemos acionar a polícia para assistência."
                    />
                  </FormGroup>
                  <Typography variant="h6" fontWeight="bold">
                    6 - Dados para atendimento
                  </Typography>
                  <InputSelect
                    name="security_question"
                    label="Pergunta de segurança"
                    placeholder="Escolha uma pergunta"
                    items={itemsQuerstionSecurity}
                    setValue={(value) => {
                      setValue('security_question', +value as number);
                    }}
                  />
                  <Controller
                    name="security_answer"
                    control={control}
                    render={({ field }) => (
                      <>
                        <Input
                          label="Resposta da pergunta"
                          placeholder="Descreva o modelo"
                          error={errors?.security_answer ? true : false}
                          isDirty={dirtyFields.security_answer}
                          helperText={errors?.security_answer?.message}
                          {...field}
                        />
                      </>
                    )}
                  />
                </Box>
                <Box sx={styles.containerButton}>
                  <LoadingButton data-testid="contract-step5-next" variant="contained" loading={loading} type="submit">
                    Finalizar preenchimento
                  </LoadingButton>
                </Box>
              </form>
            </CardContent>
          </Card>
        </Grid>
        <Grid
          item
          md={4}
          xs={12}
          sx={{
            display: {
              xs: 'none',
              lg: 'block'
            }
          }}
        >
          <Card>
            <CardContent>
              <SidebarMesages showProduct={true} />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
}
